import { Box } from '@chakra-ui/react';
import { Text } from '@kula-ai/components';
import { colors } from '@/theme/foundations/colors';
import { isBlankValue } from './calculatedControlValue';

export interface NeededForNoteProps {
  // Handed down by the form builder's after-content slot.
  value?: unknown;
  // The calculated field waiting on this one.
  neededFor: string;
}

/**
 * Sits under a field a formula is waiting on, and says which formula.
 *
 * Rendered below the control rather than as a sub-label: the formula field's
 * own "Fill in X to see this value" is below, and the two red lines read as
 * one convention only if they sit in the same place (Venil).
 */
export const NeededForNote = ({ value, neededFor }: NeededForNoteProps) =>
  isBlankValue(value) ? (
    // kula Text drops data-* attributes, so the hook sits on the wrapper.
    <Box mt="1" data-test-id="needed-for-note">
      <Text variant="small" style={{ color: colors['pastel-1-dark'] }}>
        {`This field is needed to compute the "${neededFor}" field`}
      </Text>
    </Box>
  ) : null;
